import { render } from "./ballance.vue?vue&type=template&id=5138103a"
import script from "./ballance.vue?vue&type=script&lang=js"
export * from "./ballance.vue?vue&type=script&lang=js"

import "./ballance.vue?vue&type=style&index=0&id=5138103a&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__